import { defineStore } from "pinia";
import { postApi } from "@/api";

export const usePostCategoryStore = defineStore("postCategory", {
  state: () => ({
    postCategory: [],
  }),

  actions: {
    async fetchCategories() {
      try {
        const response = await postApi.getPostCategorys();
        this.postCategory = response;
      } catch (error) {
        console.error("获取分类失败:", error);
      }
    },
  },
}); 